"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spellingHtmlReading = exports.tokenizeExplicitSpelling = exports.hasValidMarkup = exports.isLogogramNumberPhrase = exports.isComplementPhrase = exports.isSignPhraseWithNumber = exports.isNumberPhrase = exports.isNumberSign = exports.separateTokenPhrases = void 0;
var signNormalizer_1 = require("./signNormalizer");
var spellingParser = require('./spellingParser');
var withLexDebugger = function (rawTokens, parse) {
    var globals = globalThis;
    var previous = globals.Jison;
    globals.Jison = { lexDebugger: rawTokens };
    try {
        return parse();
    }
    finally {
        globals.Jison = previous;
    }
};
var separateTokenPhrases = function (tokens) {
    var phrases = [];
    var curPhrase = [];
    tokens.forEach(function (token) {
        if (token.tokenType === 'SPACE') {
            phrases.push(__spreadArray([], curPhrase, true));
            curPhrase = [];
        }
        else {
            curPhrase.push(token);
        }
    });
    phrases.push(__spreadArray([], curPhrase, true));
    return phrases;
};
exports.separateTokenPhrases = separateTokenPhrases;
var normalizeRawTokens = function (rawTokens) {
    return rawTokens.map(function (_a) {
        var tokenType = _a.tokenName[0], tokenText = _a.tokenText;
        return ({
            tokenType: tokenType,
            tokenText: tokenText,
        });
    });
};
var isNumberSign = function (tokenText) {
    var fullNumbers = [
        '1/2',
        '1/3',
        '1/4',
        '1/5',
        '1/6',
        '2/3',
        '3/4',
        '5/6',
        '½',
        '⅓',
        '¼',
        '⅕',
        '⅙',
        '⅔',
        '¾',
        '⅚',
        'LÁ',
    ];
    var decimalRegex = /^\d+(\.\d+)?$/;
    return fullNumbers.includes(tokenText) || !!tokenText.match(decimalRegex);
};
exports.isNumberSign = isNumberSign;
var isNumberPhrase = function (tokens) {
    var separators = tokens.filter(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === '+';
    });
    var signs = tokens.filter(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === 'NUMBER';
    });
    return (separators.length + signs.length ===
        tokens.filter(function (_a) {
            var tokenType = _a.tokenType;
            return tokenType !== '$end';
        }).length);
};
exports.isNumberPhrase = isNumberPhrase;
var isSignPhraseWithNumber = function (tokens) {
    if (tokens.length > 0 && tokens[0].tokenType === 'NUMBER') {
        var separators_1 = tokens.filter(function (_a) {
            var tokenType = _a.tokenType;
            return tokenType === '-' || tokenType === '.';
        });
        var signs = tokens.filter(function (_a) {
            var tokenType = _a.tokenType;
            return tokenType === 'SIGN';
        });
        return (separators_1.every(function (_a) {
            var tokenType = _a.tokenType;
            return tokenType === separators_1[0].tokenType;
        }) &&
            separators_1.length + signs.length ===
                tokens.filter(function (_a) {
                    var tokenType = _a.tokenType;
                    return tokenType !== '$end';
                }).length - 1);
    }
    return false;
};
exports.isSignPhraseWithNumber = isSignPhraseWithNumber;
var isComplementPhrase = function (tokens) {
    return tokens.some(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === '{';
    });
};
exports.isComplementPhrase = isComplementPhrase;
var isLogogramNumberPhrase = function (tokens) {
    var separators = tokens.filter(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === '.';
    });
    var signs = tokens.filter(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === 'SIGN' || tokenType === 'NUMBER';
    });
    return (separators.every(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === separators[0].tokenType;
    }) &&
        signs.some(function (_a) {
            var tokenType = _a.tokenType;
            return tokenType === 'SIGN';
        }) &&
        signs.some(function (_a) {
            var tokenType = _a.tokenType;
            return tokenType === 'NUMBER';
        }) &&
        separators.length + signs.length ===
            tokens.filter(function (_a) {
                var tokenType = _a.tokenType;
                return tokenType !== '$end';
            }).length);
};
exports.isLogogramNumberPhrase = isLogogramNumberPhrase;
var hasValidMarkup = function (tokens) {
    var dualCharacterMap = {
        '*': '*',
        ':': ':',
        '‹': '›',
        '«': '»',
        '[': ']',
        '⸢': '⸣',
    };
    var reading = tokens.map(function (_a) {
        var tokenText = _a.tokenText;
        return tokenText;
    }).join('');
    var markupValid = Object.entries(dualCharacterMap).reduce(function (valid, _a) {
        var startChar = _a[0], endChar = _a[1];
        if (!valid) {
            return false;
        }
        var seenStart = false;
        var bracketsValid = true;
        reading.split('').forEach(function (char) {
            if (!bracketsValid) {
                return;
            }
            if (!seenStart) {
                if (char === startChar) {
                    seenStart = true;
                }
                else if (char === endChar) {
                    bracketsValid = false;
                }
            }
            else {
                if (char === startChar) {
                    bracketsValid = false;
                }
                else if (char === endChar) {
                    seenStart = false;
                }
            }
        });
        return seenStart ? false : bracketsValid;
    }, true);
    return markupValid;
};
exports.hasValidMarkup = hasValidMarkup;
var validName = function (tokens) {
    for (var i = 0; i < tokens.length; i += 1) {
        var token = tokens[i];
        if (token.tokenType === '=' && tokens[i + 2].tokenText !== 'd') {
            return false;
        }
    }
    return true;
};
var isValidGrammar = function (tokens, acceptMarkup) {
    if (acceptMarkup === void 0) { acceptMarkup = false; }
    if (tokens.some(function (_a) {
        var tokenText = _a.tokenText;
        return (0, exports.isNumberSign)(tokenText);
    }) &&
        !(0, exports.isComplementPhrase)(tokens)) {
        return ((0, exports.isNumberPhrase)(tokens) ||
            (0, exports.isSignPhraseWithNumber)(tokens) ||
            (0, exports.isLogogramNumberPhrase)(tokens));
    }
    var markupCharacters = '*:×‹«+#⸢⸣[]!›»?'.split('');
    if (!acceptMarkup &&
        tokens
            .map(function (_a) {
            var tokenText = _a.tokenText;
            return tokenText;
        })
            .join('')
            .split('')
            .some(function (char) { return markupCharacters.includes(char); })) {
        return false;
    }
    if (acceptMarkup && !(0, exports.hasValidMarkup)(tokens)) {
        return false;
    }
    if (tokens.some(function (_a) {
        var tokenType = _a.tokenType;
        return tokenType === '=';
    }) && !validName(tokens)) {
        return false;
    }
    return true;
};
var tokenizeExplicitSpelling = function (spelling, options) {
    if (options === void 0) { options = { acceptMarkup: false }; }
    var rawTokens = [];
    withLexDebugger(rawTokens, function () { return spellingParser.parse(spelling.trim()); });
    var normalizedRawTokens = normalizeRawTokens(rawTokens).map(function (_a) {
        var tokenType = _a.tokenType, tokenText = _a.tokenText;
        return ({
            tokenType: (0, exports.isNumberSign)(tokenText) ? 'NUMBER' : tokenType,
            tokenText: tokenText,
        });
    });
    var phrases = (0, exports.separateTokenPhrases)(normalizedRawTokens);
    if (!phrases.every(function (tokens) { return isValidGrammar(tokens, options.acceptMarkup); })) {
        throw new Error('Invalid grammar');
    }
    return normalizedRawTokens;
};
exports.tokenizeExplicitSpelling = tokenizeExplicitSpelling;
var spellingHtmlReading = function (spelling, options) {
    if (options === void 0) { options = { acceptMarkup: false }; }
    if (!spelling) {
        return '';
    }
    try {
        var tokens_1 = (0, exports.tokenizeExplicitSpelling)(spelling, options);
        return tokens_1
            .filter(function (_a) {
            var tokenType = _a.tokenType;
            return tokenType !== '$end';
        })
            .map(function (_a, index) {
            var tokenType = _a.tokenType, tokenText = _a.tokenText;
            if (tokenType === 'SIGN') {
                var sign = (0, signNormalizer_1.normalizeSign)(tokenText);
                if (index > 0) {
                    var prevToken = tokens_1[index - 1].tokenText;
                    if (prevToken === '(' || prevToken === '{') {
                        return "<sup>".concat(sign, "</sup>");
                    }
                }
                return sign === sign.toLowerCase() ? "<em>".concat(sign, "</em>") : sign;
            }
            if (tokenType === 'DETSEPARATOR') {
                return '<sup>.</sup>';
            }
            if (tokenType === 'COMPSEPARATOR') {
                return '<sup>-</sup>';
            }
            if (tokenType === 'SPACE') {
                return '&nbsp;';
            }
            if (tokenType === '=') {
                return '-';
            }
            if (tokenType === 'NUMBER') {
                return (0, signNormalizer_1.normalizeFraction)(tokenText);
            }
            if (['SIGN', '+', '.', '-'].includes(tokenType)) {
                return tokenText;
            }
            return '';
        })
            .join('');
    }
    catch (e) {
        return "<mark style=\"background-color: #ffb3b3\">".concat(spelling, "</mark>");
    }
};
exports.spellingHtmlReading = spellingHtmlReading;
//# sourceMappingURL=spellingTokenizer.js.map